import styled from 'styled-components';
import { Button } from 'edenred-ui';

export const StyledToggleButton = styled(Button)`
  border: 1px solid ${props => props.theme.primaryFrontColor};
  padding: 8px 24px;
  height: 40px;
  border-radius: 20px;

  & > span > span {
    display: flex;
    gap: 16px;
    justify-content: space-between;
    align-items: center;
  }
`;
